import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.3 6.6c.368 0 .667.299.667.667v4a.667.667 0 0 1-1.333 0v-4c0-.368.298-.667.666-.667M7.3 7.267a.667.667 0 0 0-1.333 0v4a.667.667 0 1 0 1.333 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.634 3.267V2.6a2 2 0 0 1 2-2H9.3a2 2 0 0 1 2 2v.667h2.667a.667.667 0 1 1 0 1.333H13.3v8.667a2 2 0 0 1-2 2H4.634a2 2 0 0 1-2-2V4.6h-.667a.667.667 0 0 1 0-1.333zm1.528-1.138a.67.67 0 0 1 .472-.196H9.3a.667.667 0 0 1 .667.667v.667h-4V2.6c0-.177.07-.346.195-.471M3.967 13.267V4.6h8v8.667a.667.667 0 0 1-.667.666H4.634a.667.667 0 0 1-.667-.666",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })